import React from 'react';
import FaceSwapHeader from './FaceSwapHeader';
import FaceSwapMain from './FaceSwapMain';
import Footer from './Footer';
import './FaceSwapPage.css';

const FaceSwapPage: React.FC = () => {
  return (
    <div className="face-swap-page">
      {/* Header */}
      <FaceSwapHeader />
      
      {/* Main Content */}
      <FaceSwapMain />
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default FaceSwapPage;